/**
 * @deprecated It will be removed in 6 months 09-20-2025. Pass format as string literal instead.
 * The consumer of a component/formatter should control the formatter's workability.
 * */
export const DateFormats: Record<string, string> = {
    DATE_MONTH_YEAR: 'MMM YYYY',
    FULL_DATE_MONTH_YEAR: 'DD MMM YY',
    FULL_MONTH_YEAR: 'MMMM YYYY',
    DATE_MONTH: 'MMM',
    DATE_YEAR: 'YYYY',
    DATE_YEAR_QUARTER: 'YYYY [Q]Q',
    DATE: 'DD-MMM-YYYY',
    DDMMMYY: 'DD-MMM-YY',
    DDMMM: 'DD-MMM',
    MMMDD: 'MMM DD',
    DAY_OF_WEEK: 'dddd',
    MMDDYYYY: 'MM-DD-YYYY',
    DDMMYYYY: 'DD-MM-YYYY',
    DDMMMYYYY: 'DD-MMM-YYYY',
    YYYYMMDD: 'YYYY-MM-DD',
    DDMMMMYY: 'DD-MMMM-YY',
    LOG_BACK_IN: 'MM/DD/YYYY hh:mm:ss A',
    DATE_TIME: 'DD-MMM-YYYY [at] hh:mm A',
    DATE_FULL_TIME: 'YYYY_DD_MM_H_mm_ss',
    HOURS: 'h:mm a',
    FULL_HOURS: 'HH:mm',
};

/**
 * @deprecated It will be removed in 6 months 09-15-2025. Use string literal instead
 * */
export type DateFormatsType = string;

/**
 * @deprecated It will be removed in 6 months 09-15-2025. Use string literal instead
 * */
export type DateFormat = string;
